import React from 'react';
import { Form, Label, Select, LabelInput, DatePickerInput } from '../../common/components/form';
import moment from 'moment';

import { Localize } from '../../../locale/localization';

const TransactionsSearchForm = props => {
  const {
    onSubmit,
    onInputChange,
    dateFrom,
    dateTo,
    salesId,
    count,
  } = props;

  const firstPossibleDate = moment().startOf('year'),
    lastPossibleDate = moment().endOf('day');

  return (
    <Form onSubmit={onSubmit} autoCorrect="off" autoComplete="off" noValidate spellCheck="false">
      <Label half tight label={Localize('transaction.search.date.from')}>
        <DatePickerInput
          type="text"
          name="dateFrom"
          strict={true}
          value={dateFrom}
          onChange={onInputChange}
          firstPossibleDate={firstPossibleDate}
          lastPossibleDate={lastPossibleDate}
        />
      </Label>
      <Label half tight label={Localize('transaction.search.date.to')}>
        <DatePickerInput
          type="text"
          name="dateTo"
          strict={true}
          value={dateTo}
          onChange={onInputChange}
          firstPossibleDate={firstPossibleDate}
          lastPossibleDate={lastPossibleDate}
        />
      </Label>
      <LabelInput
        half
        type="text"
        label={Localize('transaction.search.salesId')}
        name="salesId"
        value={salesId}
        onChange={onInputChange}
      />
      <Label label={Localize('transaction.search.count')} half>
        <Select value={count} name="count" onChange={onInputChange}>
          <option id="5" value="5">
            5
          </option>
          <option id="10" value="10">
            10
          </option>
          <option id="15" value="15">
            15
          </option>
          <option id="25" value="25">
            25
          </option>
          <option id="50" value="50">
            50
          </option>
        </Select>
      </Label>
    </Form>
  );
};

export default TransactionsSearchForm;



// WEBPACK FOOTER //
// ./src/modules/transaction/components/TransactionsSearchForm.js